import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

function ManageSitePublisherMenu({ openItem = null, activeItem = null }) {
  return (
    <>
      <li
        className={`nav-item has-treeview 
                  ${sidebarHelper.checkOpenItem(
                    openItem,
                    "manage-category-publisher-menu"
                  )} `}
      >
        <a
          href="# "
          className={`nav-link  
                  ${sidebarHelper.checkActiveItem(
                    openItem,
                    "manage-category-publisher-menu"
                  )} `}
        >
          <i className="nav-icon fa fa-globe "></i>
          <p style={{ fontSize: "12px" }}>
            مدیریت سایت های نمایش دهنده
            <i className="right fa fa-angle-left"></i>
          </p>
        </a>

        <ul className="nav nav-treeview">
          <li className="nav-item">
            <Link
              to="/manage/publishers/all"
              className={`nav-link  
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "manage-publisher"
                      )} `}
            >
              <i className="fa fa-list nav-icon"></i>
              <p>سایت های نمایش دهنده</p>
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/manage/category-publishers/all"
              className={`nav-link  
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "manage-category-publisher"
                      )} `}
            >
              <i className="fa fa-list  nav-icon"></i>
              <p>دسته های صنفی</p>
            </Link>
          </li>

          <li className="nav-item">
            <Link
              to="/manage/category-user-site-publishers/"
              className={`nav-link  
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "manage-category-user-site-publishers"
                      )} `}
            >
              <i className="fa fa-list  nav-icon"></i>
              <p style={{ fontSize: "11px" }}>
                دسته سایت های نمایش دهنده کاربران
              </p>
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/manage/publishers/all-banner-category-site-publisher-alternative"
              className={`nav-link  
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "manage-type-category-user-site-publishers-alternative"
                      )} `}
            >
              <i className="fa fa-list  nav-icon"></i>
              <p style={{ fontSize: "11px" }}>
                دسته سایت های نمایش دهنده جایگزین
              </p>
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/manage/publishers/report-position"
              className={`nav-link  
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "report-position"
                      )} `}
            >
              <i className="fa fa-list  nav-icon"></i>
              <p>گزارش جایگاه</p>
            </Link>
          </li>
          <li className="nav-item">
            <Link
              to="/manage/publishers/check-position"
              className={`nav-link  
                      ${sidebarHelper.checkActiveItem(
                        activeItem,
                        "check-position"
                      )} `}
            >
              <i className="fa fa-list  nav-icon"></i>
              <p>بررسی جایگاه ها</p>
            </Link>
          </li>
        </ul>
      </li>
    </>
  );
}

export default ManageSitePublisherMenu;
